import { Dialog } from 'quasar'
import { createErrorFromResponse } from 'src/utils/error'
import i18n from 'src/i18n/i18n'
import router from 'src/router'
import store from 'src/store'

function cancelInvoice (invoiceId) {
  store.dispatch('setInvoiceStatus', { invoiceId, status: 'canceled' })
    .then(invoice => router.push({ 'name': 'invoice', params: { teamId: store.getters.activeTeam.id, invoice: invoice.canceled_by.data.id } }))
    .catch(createErrorFromResponse)
}

export default function handleCancelInvoice (invoiceId) {
  Dialog.create({
    title: i18n.t('cancel_invoice_dialog_heading'),
    message: i18n.t('cancel_invoice_dialog_body'),
    color: 'primary',
    ok: i18n.t('cancel_invoice'),
    cancel: i18n.t('cancel')
  })
    .then(() => cancelInvoice(invoiceId))
    .catch(() => {})
}
